<template>
  <div>
    <v-dialog v-model="visible" v-if="redirectToDashboard && !isError && !isWarning" persistent width="300">
      
      
      <v-card>
        <v-toolbar height="40" window>
          <span></span>
          <v-spacer></v-spacer>
          <v-icon color="black" class="me-3" @click="reload()">mdi-close-circle-outline</v-icon>
        </v-toolbar>
        <v-card-title style="white-space: normal; word-break: break-word;">
          {{ message }}
        </v-card-title>
        <v-card-text class="word-break">
          {{ $t('Redirect_After_Save_MOC_Confirmation') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" class="text-button" elevation="0"  @click="reload()">{{ $t('No') }}</v-btn>
          <v-btn variant="text" class="text-button" elevation="0" color="green" @click="redirect">{{ $t('Yes') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay class="align-center justify-center" v-model="visible" v-if="!redirectToDashboard && !isError && !isWarning" :z-index="999999999">
      <v-progress-circular :size="70" :width="7" color="white" indeterminate></v-progress-circular>
    </v-overlay>
    <!-- error start-->
    <v-dialog v-model="visible" v-if="isError" persistent width="400">
      <v-card>
        <v-toolbar height="40" window color="red">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon color="black" class="me-3" @click="visible = false">mdi-close-circle-outline</v-icon>
        </v-toolbar>
        <v-card-title style="white-space: normal; word-break: break-word;">
          {{ message }}
        </v-card-title>
        <v-card-text class="word-break">
          <div v-if="errorDetails && errorDetails.message === $t('Someone_Else_Already_Change_This')" >
            {{ $t('Try_Again_And_Reload_After_Save_MOC_Error') }}
          </div>
          <div v-else-if="errorDetails && (errorDetails.response || {}).status === 404">
            {{ $t('Please_Check_Url') }}
          </div>
          <div v-else>
            {{ $t('Try_Again_After_Save_MOC_Error') }}
          </div>
        </v-card-text>
        <v-container>
          <div class="d-flex mb-2">
            <v-btn small color="red" class="white--text" v-if="errorDetails" @click="showDetails = !showDetails">{{
              showDetails ? $t('Hide_IT_Support_Details') : $t('Show_IT_Support_Details')
            }}</v-btn>
          </div>
          <div v-if="showDetails" class="d-flex justify-end">
            <v-tooltip bottom>
              <template v-slot:activator="{ props }">
                <v-btn icon v-bind="props">
                  <v-icon @click="copyToClipboard()">mdi-content-copy</v-icon>
                </v-btn>
                
              </template>
              <span>{{ $t('Copy_To_Clipboard') }}</span>
            </v-tooltip>
          </div>
          <v-textarea v-if="showDetails" ref="errorDetailsElement" v-model="errorString"></v-textarea>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="visible = false" v-if="!redirectToDashboard">{{ $t('OK') }}</v-btn>
          <v-btn text @click="goHome()" v-if="redirectToDashboard">{{ $t('OK') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- error end -->
    <!-- warning start -->
    <v-dialog v-model="visible" v-if="isWarning" persistent width="400">
      <v-card>
        <v-system-bar height="40" window color="orange">
          <span></span>
          <v-spacer></v-spacer>
          <v-icon color="black" @click="visible = false">mdi-close-circle-outline</v-icon>
        </v-system-bar>
        <v-card-title style="white-space: normal; word-break: break-word;">
          {{ message }}
        </v-card-title>

        <v-container>
          <v-textarea ref="warningDetailsElement" v-model="warningString"></v-textarea>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="visible = false" v-if="!redirectToDashboard">{{ $t('OK') }}</v-btn>
          <v-btn text @click="goHome()" v-if="redirectToDashboard">{{ $t('OK') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--warning end -->
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import Toaster from '@/components/Toaster'

export default {
  name: 'LoadingDialog',
  data() {
    return {
      visible: false,
      redirectToDashboard: false,
      message: this.$t('Success_Saved'),
      isError: false,
      errorDetails: {
        message: '',
        stack: '', 
        response: '',
        metadata: '', 
        error: ''
      },
      showDetails: false,
      isWarning: false,
      warningDetails: undefined
    }
  },
  components: {
    Toaster
  },
  props: {
    mocId: {
      type: String,
      default: undefined
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide(params) {
      const { message = this.$t('Success_Saved'), redirect = false } = params || {}
      if (redirect) {
        this.redirectToDashboard = redirect
        this.message = message
        return
      }
      this.visible = false
    },
    redirect() {
      this.visible = false
      const path = this.$route.params.shortName ? `/${this.$route.params.shortName}/CommunityDashboard` : '/CommunityDashboard'
      this.$router.push({ path })
    },
    goHome() {
      this.redirect()
    },
error(params) {
  if (!this.visible) {
    this.visible = true;
  }

  const {
    message = this.$t('Error_Save'),
    redirect = false,
    error,
    metadata
  } = params;

  let finalMessage = message;

  const status = error?.response?.status;

  switch (status) {
    case 400:
      finalMessage = this.$t('MOC_Does_Not_Exist');
      this.redirectToDashboard = redirect;
      break;
    case 404:
      finalMessage = this.$t('MOC_Not_Found_Bad_Url');
      break;
  }

  this.errorDetails.error = error;
  this.errorDetails.metadata = metadata;

  this.errorDetails.message = message === 'Someone_Else_Already_Change_This'
    ? this.$t('Someone_Else_Already_Change_This')
    : finalMessage;

    this.message = finalMessage;

  this.isError = true;
},
    warning(params) {
      if (!this.visible) {
        this.visible = true
      }
      let { message = this.$t('Error_Save'), redirect = false, warning, metadata } = params

      this.warningDetails = warning
      this.warningDetails.metadata = metadata
      this.message = message
      this.isWarning = true
    },
    reload() {
      if (this.mocId) {
        const path = `/${this.$route.params.shortName}/moc/${this.mocId}`
        if (this.$route.fullPath === path) {
          this.$router.go(0)
        } else {
          this.$router.replace({ path })
        }
      } else {
        this.$router.go(0)
      }
    },
    copyToClipboard() {
      try {
        const errorDetailsElement = this.$refs.errorDetailsElement.$refs.input
        errorDetailsElement.focus()
        errorDetailsElement.select()
        const successful = document.execCommand('copy')
        if (successful) {
          this.$refs.toaster.pop('success', this.$t('Copy_To_Clipboard_Success'))
        } else {
          this.$refs.toaster.pop('error', this.$t('Copy_To_Clipboard_Failed'))
        }
      } catch (err) {
        this.$refs.toaster.pop('error', this.$t('Copy_To_Clipboard_Failed'))
      }
    }
  },
  computed: {
    errorString() {
      if (this.errorDetails) {
        return `${this.errorDetails.metadata ? this.errorDetails.metadata + ':' : ''} ${this.errorDetails.stack}`
      }
      return ''
    },
    warningString() {
      if (this.warningDetails) {
        return `${this.warningDetails.metadata ? this.warningDetails.metadata + ':' : ''}`
      }
      return ''
    }
  },
  watch: {
    visible(newValue) {
      if (!newValue) {
        this.redirectToDashboard = false
        this.isError = false
        this.isWarning = false
        this.errorDetails.message= ''
        this.errorDetails.stack=''
        this.errorDetails.response=''
        this.errorDetails.metadata= ''
        this.errorDetails.error= ''
        this.showDetails = false
      }
    }
  }
}
</script>

<style>
.word-break {
  word-break: break-word;
}
.text-button { 
   background-color: transparent !important;   
  }
</style>
